export default {
  data: function() {
    return {
      // Default data
      sortByData: [
        {
          name: 'Default',
          field: ['sort', 'default'],
          ascending: true,
          default: true,
          multi: {
            fields: ['apr'],
            order: ['asc']
          }
        },
        {
          name: 'APR',
          field: 'apr',
          ascending: true
        },
        {
          name: 'Est Payment',
          field: 'estimatedpayment',
          ascending: true,
          multi: {
            fields: ['apr', 'surveydate'],
            order: ['desc', 'desc']
          }
        },
        {
          name: 'Lender',
          field: 'advertiser',
          ascending: true,
          multi: {
            fields: ['apr', 'estimatedpayment', 'surveydate'],
            order: ['desc', 'asc', 'desc']
          }
        }
      ],

      // Sort drop-down
      sortSingleItems: [],
      sortSingleSelected: ''
    }
  }
}
